export const MAYBE_FETCH_PROFILE_DATA = '@@od/store/homeProfile/maybeFetchProfileData';
export const BEGIN_LOADING_PROFILE_DATA = '@@od/store/homeProfile/beginLoadingProfileData';
export const RECEIVE_DATA = '@@od/store/homeProfile/receiveData';
export const ERROR_PROFILE_DATA = '@@od/store/homeProfile/errorProfileData';
export const CLEAR_PROFILE_DATA = '@@od/store/homeProfile/clearProfileData';
export const MAYBE_FETCH_MARKET_TRENDS = '@@od/store/homeProfile/maybeFetchMarketTrends';
export const RECEIVE_MARKET_TRENDS = '@@od/store/homeProfile/receiveMarketTrends';
export const TO_INPUT_FLOW = '@@od/store/homeProfile/toInputFlow';
export const TRACK_EVENT = '@@od/store/homeProfile/trackEvent';
export const TRACK_LEAD = '@@od/store/homeProfile/trackLead';
